import React, { useEffect, useMemo, useState } from "react";
import style from "./index.module.css";
import edit from "../../../Assets/edit3.svg";
import BackIcon from "../../../Assets/BackIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../../services/api";
import { studentActions } from "../../../redux/actions";
import profile from "../../../Assets/newProfile.svg";
import swAlert from "sweetalert2";

const Editprofile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const student = useSelector((state) => state.student);

  const location = useLocation();

  const [input, setInput] = useState({
    firstname: "",
    email: "",
    lastname: "",
    image: "",
    walletId: "",
  });

  const [iswalletIdVisible, setiswalletIdVisible] = useState(false);

  const preview = useMemo(() => {
    return input.image && typeof input.image !== "string"
      ? URL.createObjectURL(input.image)
      : null;
  }, [input.image]);
  useEffect(() => {
    if (location.pathname === "/hiring/student/Editprofile") {
      setiswalletIdVisible(true);
    }
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user._id;
    dispatch(studentActions.setStudent(userId));
  }, [location]);

  useEffect(() => {
    if (student?.name) {
      setInput((state) => ({
        ...state,
        firstname: student?.name.split(" ")[0],
        lastname: student?.name.split(" ")[1],
      }));
      // Swal.fire('user name changed succesfully');
    }
    if (student?.email) {
      setInput((state) => ({
        ...state,
        email: student?.email,
      }));
    }
    if (student?.walletId) {
      setInput((state) => ({
        ...state,
        walletId: student?.walletId,
      }));
    }
  }, [student]);

  const [formData, setFormData] = useState([]);
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInput({ ...input, [name]: value });
  };

  const changeImage = (e) => {
    // alert("Will be implemented soon!");
    e.preventDefault();

    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      if (!allowedExtensions.exec(selectedFile?.name)) {
        swAlert.fire({
          icon: "warning",
          title: "Please upload jpg/jpeg/png file...",
          timer: 2000,
        });
        return;
      }
      setInput((state) => ({
        ...state,
        image: e.target.files[0],
      }));
    } else {
      swAlert.fire({
        icon: "warning",
        title: "File size should be less than 5MB",
        timer: 2000,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      input.firstname &&
      input.email &&
      !(input.image && typeof input.image !== "string")
    ) {
      api
        .editProfile({
          name: `${input.firstname} ${input.lastname}`,
        })
        .then((_) => {
          swAlert.fire({
            icon: "success",
            text: "Changes saved successfully...",
            timer: 2000,
          });
          navigate(-1);
          api.updateWalletId(input.walletId).then((_) => {
            navigate(-1);
          });
        });
    } else if (
      input.firstname &&
      input.email &&
      input.image &&
      typeof input.image !== "string"
    ) {
      api
        .editProfile({
          name: `${input.firstname} ${input.lastname}`,
        })
        .then((_) => {
          const uploadData = new FormData();
          uploadData.append("file", input.image);
          // ToDo Manage Errors
          if (input.image) {
            api.changeProfilePhoto(uploadData).then((_) => {});
          }
          swAlert.fire({
            icon: "success",
            text: "Changes saved successfully...",
            timer: 1500,
          });
          navigate(-1);
          setInterval(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((e) => {
          swAlert.fire({
            icon: "warning",
            text: "OOPS! Something went wrong.",
            timer: 1300,
          });
        });
    } else {
      swAlert.fire({
        icon: "warning",
        title: "Please fill data",
        timer: 1300,
      });
    }
  };

  return (
    <div className={style.container}>
      <div className={style.profilecont}>
        <div className={style.EditTxt}>
          <div
            onClick={() => navigate(-1, { replace: true })}
            className={style.backIcon}
          >
            <img src={BackIcon} alt="" />
          </div>
          <div>Edit Profile</div>
        </div>
        <div className={style.userprofile}>
          {input?.image ? (
            <img src={preview} alt="profile" />
          ) : (
            <img src={student?.profilePhoto || profile} alt="profile" />
          )}
          {/* <img src={profile} alt='userprofile' /> */}
        </div>
        {/* <div className={style.changepwrd}>Change Picture</div> */}
        <label htmlFor="imgEdit" className={style.edit}>
          <img src={edit} alt="editIcon" />
          <input
            type="file"
            id="imgEdit"
            name="image"
            onChange={changeImage}
            hidden
          />
        </label>
      </div>
      <form className={style.formContainer}>
        <div className={style.iconInput}>
          <div className={style.passwordEyeIcon}>
            <input
              type="text"
              name="firstname"
              placeholder="First name"
              value={input.firstname}
              onChange={handleChange}
              required
              autoComplete="off"
            />
          </div>
        </div>
        <div className={style.iconInput}>
          <div className={style.passwordEyeIcon}>
            <input
              type="text"
              name="lastname"
              placeholder="Last name"
              value={input.lastname}
              onChange={handleChange}
              required
              autoComplete="off"
            />
          </div>
        </div>
        <div className={style.iconInput} style={{ cursor: "not-allowed" }}>
          {/* <img src={mail} alt='emailIcon' /> */}
          <input
            type="email"
            placeholder="Email Address"
            name="email"
            value={input.email}
            disabled
            style={{ cursor: "not-allowed" }}
            autoComplete="off"
          />
        </div>
        {iswalletIdVisible && (
          <div className={style.iconInput}>
            {/* <img src={mail} alt='emailIcon' /> */}
            <input
              type="text"
              placeholder="Enter marketplace Id"
              name="walletId"
              value={input.walletId}
              onChange={handleChange}
              autoComplete="off"
            />
          </div>
        )}
        <div className={style.loginBtn}>
          <button
            type="button"
            onClick={handleSubmit}
            style={{ background: "#6C56FB", color: "white" }}
          >
            Save
          </button>
          <button type="button" onClick={() => navigate(-1)}>
            Discard
          </button>
        </div>
      </form>
    </div>
  );
};

export default Editprofile;
